import * as React from 'react';
import { SVGProps } from 'react';
import { withForgeIconProps } from './ForgeIconProps';
interface SVGRProps {
  title?: string;
  titleId?: string;
}

const SvgCollapseLarge = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps): JSX.Element => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="fi_c_icon"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M1 17.395L12.11 6.5L23 17.395"
      stroke={props.color}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

SvgCollapseLarge.displayName = 'SvgCollapseLarge';
const CollapseLarge = withForgeIconProps(SvgCollapseLarge, {
  name: 'Collapse',
  usage: 'Use to collapse an Accordion or a dropdown.',
  related: 'close',
  isLabelRequired: false,
  isNeutralInteractive: true,
  size: 'large',
});
export default CollapseLarge;
